import { createContext, useContext } from 'react';

export type ScrollPosition = {
  scrollPosition: number;
};

export const ScrollPositionContext = createContext<ScrollPosition | null>(null);

const emptyContext = {} as ScrollPosition;

export const useScrollPositionContext = () => {
  const selectScrollPositionContext = useContext(ScrollPositionContext);
  return selectScrollPositionContext ?? emptyContext;
};
